import { RouteMatch } from 'react-router';

import { HeaderSection } from '@/common/constants/HeaderSection';

export interface AppRouteHandle {
  headerSection?: Nullable<HeaderSection>;
}

export function getHeaderSectionByRouteMatches(matches: Nullable<RouteMatch[]>): Nullable<HeaderSection> {
  const headerSections = (matches ?? [])
    .map((match) => (match.route.handle as Nullable<AppRouteHandle>)?.headerSection)
    .filter((headerSection) => headerSection !== undefined);

  const lastHeaderSection = headerSections.at(-1);

  return lastHeaderSection ?? null;
}
